import { Table, TableCombination, TableSubscriber, TableToken } from '@backend/domain'
import { Injectable } from '@nestjs/common'
import { InjectRepository } from '@nestjs/typeorm'
import { Repository } from 'typeorm'
import { BaseEntityRepository, SoftDeleteEntityRepository, UserModifiableEntityRepository } from './generic'

@Injectable()
export class TableRepository extends SoftDeleteEntityRepository<Table> {
	constructor(@InjectRepository(Table) override readonly _repository: Repository<Table>) {
		super(_repository)
	}

	findMaxCapacity(): Promise<number | null> {
		return this._repository.maximum('capacity')
	}
}

@Injectable()
export class TableSubscriberRepository extends UserModifiableEntityRepository<TableSubscriber> {
	constructor(@InjectRepository(TableSubscriber) override readonly _repository: Repository<TableSubscriber>) {
		super(_repository)
	}
}

@Injectable()
export class TableTokenRepository extends BaseEntityRepository<TableToken> {
	constructor(@InjectRepository(TableToken) override readonly _repository: Repository<TableToken>) {
		super(_repository)
	}
}

@Injectable()
export class TableCombinationRepository extends BaseEntityRepository<TableCombination> {
	constructor(@InjectRepository(TableCombination) override readonly _repository: Repository<TableCombination>) {
		super(_repository)
	}
}
